import React from 'react';
import { Link } from 'react-router-dom';
import { PHOTO_BACKDROPS, backdropStyle } from '../config/backdrops';
import './Footer.css';

function Footer() {

  return (
    <footer
      className="footer pr-backdrop pr-backdrop--photo pr-backdrop--overlay-footer"
      style={backdropStyle(PHOTO_BACKDROPS.turtle)}
    >
      <div className="footer-content">
        <div className="footer-section">
          <h3>À propos</h3>
          <p>Découvrez les meilleurs événements et réservez vos billets en toute simplicité.</p>
        </div>
        
        <div className="footer-section">
          <h3>Liens rapides</h3>
          <ul>
            <li><Link to="/">Accueil</Link></li>
            <li><Link to="/events">Événements</Link></li>
            <li><Link to="/cart">Panier</Link></li>
            <li><Link to="/profile">Mon compte</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Contact</h3>
          <ul>
            <li><i className="fas fa-envelope"></i> contact@passreunion.com</li>
            <li><i className="fas fa-phone"></i> +262 262 123 456</li>
            <li><i className="fas fa-map-marker-alt"></i> La Réunion, France</li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Informations légales</h3>
          <ul>
            <li><Link to="/rgpd">Politique RGPD</Link></li>
            <li><Link to="/mentions-legales">Mentions légales</Link></li>
            <li><Link to="/helloasso">Paiement HelloAsso</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Suivez-nous</h3>
          <div className="social-links">
            <a href=" " target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook"></i></a>
            <a href=" " target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
            <a href=" " target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; 2024 Pass Réunion. Tous droits réservés.</p>
      </div>
    </footer>
  );
}

export default Footer; 